// extracted by mini-css-extract-plugin
export default {"forecast":"Hourly-forecast_forecast__2TKH-","forecast-container":"Hourly-forecast_forecast-container__2WAUP","forecast-title":"Hourly-forecast_forecast-title__9rGTI"};